module.exports = __webpack_public_path__ + "static/media/PaymentCheckPresenterScreen.32e7cb35.png";